import type {SelectProps} from 'antd';
import {Checkbox, Menu, Select, Space} from 'antd';
import React, {useEffect, useState} from 'react';
import {ReactComponent as SelectArrayIcon} from 'assets/i/select-array-icon.svg';
import {ReactComponent as ArrowUpIconIcon} from 'assets/i/arrow-up-icon.svg';
import {ReactComponent as CloseFormIcon} from 'assets/form/close-form.svg';
import {useAppDispatch, useAppSelector} from "common/hook";
import {setGroupIds} from "features/model/slice/create-test/create-test-form/createTestForm";

interface SelectModeGroupProps {
    onSelect: (selectedGroupIds: number[]) => void;
    onClearGroups: () => void;
    setSelectedGroupId: (value: number[]) => void;
}

export const SelectModeGroup: React.FC<SelectModeGroupProps> = ({onSelect,onClearGroups,setSelectedGroupId}) => {
    const dispatch = useAppDispatch();
    const testFormData = useAppSelector(state => state.createTestForm);
    const {selectedGroupIds} = testFormData;
    const {items, pagination, error, isLoading} = useAppSelector(state => state.groupsListing);

    const [open, setOpen] = useState<boolean>(false);

    const [value, setValue] = useState<number[]>(selectedGroupIds || []);



    useEffect(() => {
        if (value.length === 0) {
            onClearGroups();
        }
    }, [value]);

    const shouldAllowClear = value.length >= 2;


    const handleClear = () => {
        setValue([]);
        onSelect([])
    };

    useEffect(() => {
        setValue(selectedGroupIds || []);
    }, [selectedGroupIds]);

    const customClearIcon = (
        <CloseFormIcon
            onClick={() => {
                handleClear()
            }}
        />
    );

    useEffect(() => {
        dispatch(setGroupIds(value));
        setSelectedGroupId(value)
    }, [value, dispatch]);


    const options = items.map((item) => ({
        value: item.id,
        label: item.title,
    }));


    const selectProps: SelectProps = {
        mode: 'multiple',
        style: {width: '100%'},
        value,
        options,
        onChange: (newValue: number[]) => {
            setValue(newValue);
        },
        maxTagCount: 'responsive',
        onDropdownVisibleChange: (visible) => {
            setOpen(visible);
        },
        showSearch: false,
        filterOption: false,
        tokenSeparators: [],
        dropdownRender: (menu) => (
            <Menu>
                {options.map((option) => (
                    <Menu.Item key={option.value}>
                        <Checkbox
                            checked={value.includes(option.value)}
                            onChange={() => {
                                const newValue = value.includes(option.value)
                                    ? value.filter((val) => val !== option.value)
                                    : [...value, option.value];
                                setValue(newValue);
                                onSelect(newValue);
                            }}
                            className="custom-checkbox"
                        >
                            {option.label}
                        </Checkbox>
                    </Menu.Item>
                ))}
            </Menu>
        ),
    };

    return (
        <div id="select-mode">
            <Space direction="vertical" style={{width: '100%', cursor: 'pointer'}}>
                <Select
                    {...selectProps}
                    allowClear={shouldAllowClear}
                    clearIcon={customClearIcon}
                    placeholder={<span className='placeholder-text'>Доступно группе/группам</span>}
                    className={`custom-select ${open ? 'custom-select-open' : 'custom-select-closed'}`}
                    suffixIcon={open ? <ArrowUpIconIcon/> : <SelectArrayIcon/>}
                />
            </Space>
        </div>
    );
};
